import { HeadContent, Scripts } from "@tanstack/react-router";
import * as React from "react";
import { Toaster } from "ui";

interface DocumentProps {
  lang?: string;
}
export function Document(props: React.PropsWithChildren<DocumentProps>) {
  return (
    <html lang={props.lang}>
      <head>
        <HeadContent />
      </head>
      <body>
        {props.children}
        <Toaster />
        <Scripts />
      </body>
    </html>
  );
}
